import { useRef, useState } from "react";
import { Download, FileSpreadsheet, UploadCloud } from "lucide-react";
import { membershipApi } from "../api";

export function MembershipUploadPanel() {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [file, setFile] = useState<File | null>(null);
  const [uploading, setUploading] = useState(false);
  const [result, setResult] = useState<unknown>(null);

  const upload = async () => {
    if (!file) {
      alert("Please select a file.");
      return;
    }

    setUploading(true);
    try {
      const response = await membershipApi.bulkUploadMembers(file);
      setResult(response);
      setFile(null);
      if (inputRef.current) inputRef.current.value = "";
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="grid gap-6 xl:grid-cols-3">
      <section className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm xl:col-span-2">
        <h2 className="text-lg font-black text-slate-900">Upload Members</h2>

        <div className="mt-6 rounded-3xl border-2 border-dashed border-slate-200 bg-slate-50 p-8 text-center">
          <FileSpreadsheet className="mx-auto h-12 w-12 text-emerald-700" />
          <p className="mt-3 text-sm font-black text-slate-900">
            {file ? file.name : "Select Excel or CSV file"}
          </p>
          <p className="text-xs text-slate-500">Accepted: .xlsx, .xls, .csv</p>

          <input
            ref={inputRef}
            type="file"
            accept=".xlsx,.xls,.csv"
            className="hidden"
            onChange={(event) => setFile(event.target.files?.[0] ?? null)}
          />

          <button
            type="button"
            onClick={() => inputRef.current?.click()}
            className="mt-5 rounded-2xl border border-slate-200 bg-white px-5 py-3 text-sm font-black text-slate-700 hover:bg-slate-100"
          >
            Choose File
          </button>
        </div>

        <div className="mt-5 flex flex-wrap gap-3">
          <button
            type="button"
            onClick={membershipApi.downloadTemplate}
            className="inline-flex items-center gap-2 rounded-2xl border border-emerald-200 bg-emerald-50 px-5 py-3 text-sm font-black text-emerald-700"
          >
            <Download className="h-4 w-4" />
            Download Template
          </button>

          <button
            type="button"
            disabled={!file || uploading}
            onClick={upload}
            className="inline-flex items-center gap-2 rounded-2xl bg-emerald-700 px-5 py-3 text-sm font-black text-white disabled:opacity-50"
          >
            <UploadCloud className="h-4 w-4" />
            {uploading ? "Uploading..." : "Upload File"}
          </button>
        </div>
      </section>

      <section className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm">
        <h2 className="text-lg font-black text-slate-900">Upload Result</h2>

        <pre className="mt-5 overflow-auto rounded-2xl bg-slate-950 p-4 text-xs text-white">
          {result ? JSON.stringify(result, null, 2) : "No upload result yet."}
        </pre>
      </section>
    </div>
  );
}